/* eslint-disable */

import React from "react";
import { useEffect, useState } from "react";

import RaindropLoadingElement from "../../../ui-components/raindrop-loading-element/raindrop-loading-element";
import RaindropScrollContainer from "../../../ui-components/raindrop-scroll-container/raindrop-scroll-container.tsx";
import { fetchOrganisationUserGetAll } from "../../../services/api-raindrop";
import { Link } from "react-router-dom";
import JSONBlob from "../../../ui-components/json-blob/json-blob.tsx";
import OrganisationLogo from "../../../ui-components/organisation-logo/organisation-logo";
import ModelTag from "../../../ui-components/model-tag/model-tag";

const OrganisationUserRow = ({
  nameLegal,
  email,
  organisationName,
  rawData,
  organisationUrl,
}) => {
  return (
    <tr className="flex flex-row gap-4 w-full  hover:bg-color-dark-background-secondary p-2 items-center">
      <td className="w-full whitespace-nowrap flex flex-row gap-2 items-center">
        <ModelTag modelId={rawData.id} isSmall={true} />
        {nameLegal}
      </td>
      <td className="w-full whitespace-nowrap">{email}</td>
      <td className="w-full whitespace-nowrap">
        <div className="flex flex-row gap-2 items-center">
          <OrganisationLogo src={organisationUrl} isSmall={true} />
          {organisationName}
        </div>
      </td>
    </tr>
  );
};

const NimbusOrganisationUserSearch = () => {
  const [organisationUserObjects, setOrganisationUserObjects] = useState(null);

  useEffect(() => {
    fetchOrganisationUserGetAll().then((data) => {
      setOrganisationUserObjects(data);
    });
  }, []);

  if (organisationUserObjects === null) {
    return <RaindropLoadingElement />;
  }

  return (
    <div className="flex flex-col gap-2 overflow-auto w-full ">
      <RaindropScrollContainer additionalClassNames="gap-2 w-full ">
        {organisationUserObjects.map((organistionUserObject) => (
          <OrganisationUserRow
            key={organistionUserObject.id}
            nameLegal={organistionUserObject.name_legal}
            email={organistionUserObject.email}
            organisationName={organistionUserObject.organisation?.name}
            organisationUrl={
              organistionUserObject.organisation?.presigned_url_logo
            }
            rawData={organistionUserObject}
          />
        ))}
      </RaindropScrollContainer>
    </div>
  );
};

export default NimbusOrganisationUserSearch;
